/* eslint-disable no-unused-vars */
import moment from 'moment-timezone';
import { RRule } from 'rrule';
import { convertTimeZone, getDateFromString, getRetainTimeZoneInUTC, getTimeDuration, toDateString, toStringDate, toTime, toTimeEnd, toTimeStart, } from './DateFormatter';
export var getRRuleWeekFormString = function (week) {
    var _week = week.toLocaleLowerCase();
    if (_week === 'sunday') {
        return RRule.SU;
    }
    else if (_week === 'monday') {
        return RRule.MO;
    }
    else if (_week === 'tuesday') {
        return RRule.TU;
    }
    else if (_week === 'wednesday') {
        return RRule.WE;
    }
    else if (_week === 'thursday') {
        return RRule.TH;
    }
    else if (_week === 'friday') {
        return RRule.FR;
    }
    else if (_week === 'saturday') {
        return RRule.SA;
    }
    else {
        return RRule.SA;
    }
};
export var getRRuleStringValue = function (rruleString, attribute) {
    var dtStart = getDtStart(rruleString);
    var arryString = rruleString.replace('RRULE:', '').split(/\n|#/);
    var pair = (arryString === null || arryString === void 0 ? void 0 : arryString[1].split(';').find(function (a) { return a.includes(attribute); })) || '';
    return attribute === 'TZID'
        ? dtStart.timeZone
        : attribute === 'DTSTART'
            ? dtStart.time
            : pair === null || pair === void 0 ? void 0 : pair.split(/=/)[1];
};
export var getDtStart = function (rrule_string) {
    var _a, _b;
    var rule = rrule_string === null || rrule_string === void 0 ? void 0 : rrule_string.replace('RRULE:', '').split(/\n|#/);
    var dtstart = (_a = rule === null || rule === void 0 ? void 0 : rule.find(function (r) { return r.includes('DTSTART'); })) === null || _a === void 0 ? void 0 : _a.split(/;|:/);
    var timeZone = (_b = dtstart === null || dtstart === void 0 ? void 0 : dtstart.find(function (r) { return r.includes('TZID'); })) === null || _b === void 0 ? void 0 : _b.split('=')[1];
    var time = dtstart === null || dtstart === void 0 ? void 0 : dtstart[(dtstart === null || dtstart === void 0 ? void 0 : dtstart.length) - 1];
    return { timeZone: timeZone, time: time };
};
export var rRuleDateConvert = function (dtdate, duration, timeZone, bufferTZ) {
    var string_date = dtdate.split('T')[0];
    var string_time = dtdate.split('T')[1];
    var now = new Date();
    var year = string_date.slice(0, 4);
    var month = string_date.slice(4, 6);
    var day = string_date.slice(6, string_date.length);
    var hour = string_time.slice(0, 2);
    var minutes = string_time.slice(2, 4);
    var seconds = string_time.slice(4, 6);
    var tz = 'Z';
    var date = new Date(year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds + ".0" + tz);
    if (duration) {
        date = new Date(date.getTime() + duration * 60000);
    }
    if (timeZone) {
        date = new Date(convertTimeZone(date, timeZone.fromTZ, timeZone.toTZ));
    }
    if (bufferTZ) {
        date.setHours(date.getHours() - moment.tz(date, bufferTZ).utcOffset() / 60);
    }
    return date.getFullYear() + "-" + (date.getMonth() + 1)
        .toString()
        .padStart(2, '0') + "-" + date.getDate().toString().padStart(2, '0') + "|" + date
        .getHours()
        .toString()
        .padStart(2, '0') + ":" + date.getMinutes().toString().padStart(2, '0') + ":" + date
        .getSeconds()
        .toString()
        .padStart(2, '0') + "|" + date.toISOString();
};
export var changeDTSTART = function (rrule_string, date) {
    var dtstart = getRRuleStringValue(rrule_string, 'DTSTART') || '';
    var temp_date = new Date(date).toISOString().replaceAll(/-|:|/g, '');
    var date_string = temp_date.replace(temp_date.slice(-5, -1), '');
    return rrule_string.replace(dtstart, date_string);
};
export var removeUntil = function (rrule_string) {
    var until = getRRuleStringValue(rrule_string, 'UNTIL') || '';
    var temp_rule = rrule_string.replace(until, '');
    return temp_rule.replace(';UNTIL=', '');
};
export var dtStartToISO = function (rrule_string) {
    var dtstart = getRRuleStringValue(rrule_string, 'DTSTART') || '';
    return rRuleDateConvert(dtstart).split('|')[2];
};
export var endDateToISO = function (rrule_string, duration) {
    var dtstart = getRRuleStringValue(rrule_string, 'DTSTART') || '';
    var until = getRRuleStringValue(rrule_string, 'UNTIL') || '';
    if (until) {
        return rRuleDateConvert(until).split('|')[2];
    }
    return rRuleDateConvert(dtstart, duration).split('|')[2];
};
var convertRRuleDay = function (rrule_day) {
    var day = '';
    if (rrule_day === 'SU') {
        day = 'sunday';
    }
    else if (rrule_day === 'MO') {
        day = 'monday';
    }
    else if (rrule_day === 'TU') {
        day = 'tuesday';
    }
    else if (rrule_day === 'WE') {
        day = 'wednesday';
    }
    else if (rrule_day === 'TH') {
        day = 'thursday';
    }
    else if (rrule_day === 'FR') {
        day = 'friday';
    }
    else if (rrule_day === 'SA') {
        day = 'saturday';
    }
    return day;
};
export var singleOccurrenceDecode = function (start, duration, fromTZ, toTZ) {
    //TODO: Change 'EST' to timeZone
    var startDate = new Date(convertTimeZone(new Date(start), fromTZ, toTZ === 'Eastern' ? 'EST' : toTZ));
    var endDate = new Date(startDate.getTime() + duration * 60000);
    var schedule = {
        timeZone: toTZ === 'Eastern' ? 'EST' : toTZ,
        doesEnd: true,
        startDate: toDateString(startDate),
        startTime: toTime(startDate),
        endTime: toTime(endDate),
        endDate: toDateString(endDate),
        recurrence: { type: 'doesNotRepeat', value: 1, misc: '' }
    };
    return schedule;
};
export var rRuleDecode = function (rrule_string, duration, fromTZ, toTZ, scheduleTimeZone) {
    var _a, _b, _c;
    var schedule = {
        timeZone: toTZ === 'Eastern' ? 'EST' : toTZ,
        doesEnd: true,
        startDate: toDateString(new Date()),
        startTime: toTimeStart(new Date()),
        endTime: toTimeEnd(new Date()),
        endDate: toDateString(new Date()),
        recurrence: { type: 'doesNotRepeat', value: 1, misc: '' }
    };
    var timeZone = { fromTZ: fromTZ, toTZ: schedule.timeZone };
    var dtstart = getRRuleStringValue(rrule_string, 'DTSTART') || '';
    var until = getRRuleStringValue(rrule_string, 'UNTIL') || '';
    var freq = getRRuleStringValue(rrule_string, 'FREQ') || '';
    var count = getRRuleStringValue(rrule_string, 'COUNT') || '';
    var interval = getRRuleStringValue(rrule_string, 'INTERVAL') || '';
    var byweekday = ((_a = getRRuleStringValue(rrule_string, 'BYDAY')) === null || _a === void 0 ? void 0 : _a.split(',')) || '';
    var bymonthday = ((_b = getRRuleStringValue(rrule_string, 'BYMONTHDAY')) === null || _b === void 0 ? void 0 : _b.split(',')) || '';
    if (dtstart) {
        schedule.startDate = rRuleDateConvert(dtstart, undefined, timeZone, scheduleTimeZone).split('|')[0];
        schedule.startTime = rRuleDateConvert(dtstart, undefined, timeZone, scheduleTimeZone).split('|')[1];
    }
    if (until) {
        schedule.endDate = rRuleDateConvert(until, undefined, timeZone, scheduleTimeZone).split('|')[0];
        schedule.endTime = rRuleDateConvert(dtstart, duration, timeZone, scheduleTimeZone).split('|')[1];
    }
    else if (dtstart) {
        schedule.doesEnd = false;
        schedule.endTime = rRuleDateConvert(dtstart, duration, timeZone, scheduleTimeZone).split('|')[1];
    }
    if (freq) {
        schedule.recurrence.type =
            count && parseInt(count) === 1 ? 'doesNotRepeat' : freq.toLowerCase();
    }
    if (interval) {
        schedule.recurrence.value = parseInt(interval);
    }
    if (bymonthday) {
        if (parseInt(bymonthday[0])) {
            schedule.recurrence.misc = {
                day: bymonthday.map(function (day) { return parseInt(day); })
            };
        }
        else {
            schedule.recurrence.misc = {
                dow: bymonthday.map(function (day) { return parseInt(day); })
            };
        }
    }
    if (byweekday) {
        if (freq === 'MONTHLY') {
            var bday = (_c = byweekday[0]) === null || _c === void 0 ? void 0 : _c.replaceAll('+', '');
            schedule.recurrence.misc = {
                day: parseInt(bday === null || bday === void 0 ? void 0 : bday.slice(0, 1)),
                dow: bday === null || bday === void 0 ? void 0 : bday.slice(-2)
            };
        }
        else {
            schedule.recurrence.misc = byweekday.map(function (day) { return convertRRuleDay(day); });
        }
    }
    return schedule;
};
var getNthWeekDay = function (week, day) {
    var rule = RRule.MO.nth(day);
    if (week === 'MO') {
        rule = RRule.MO.nth(day);
    }
    else if (week === 'TU') {
        rule = RRule.TU.nth(day);
    }
    else if (week === 'WE') {
        rule = RRule.WE.nth(day);
    }
    else if (week === 'TH') {
        rule = RRule.TH.nth(day);
    }
    else if (week === 'FR') {
        rule = RRule.FR.nth(day);
    }
    else if (week === 'SA') {
        rule = RRule.SA.nth(day);
    }
    else if (week === 'SU') {
        rule = RRule.SU.nth(day);
    }
    return rule;
};
var ScheduleEvents = /** @class */ (function () {
    function ScheduleEvents() {
        this.config = {};
        this.startDate = new Date();
        this.endDate = new Date();
    }
    ScheduleEvents.prototype.conf = function (config, tzid) {
        this.config = config;
        this.startDate = new Date(getRetainTimeZoneInUTC(getDateFromString(toStringDate(config.startDate), config.startTime), config.timeZone, tzid));
        this.endDate = new Date(getRetainTimeZoneInUTC(getDateFromString(toStringDate(config.endDate), config.endTime), config.timeZone, tzid));
        var durationStart = getDateFromString(toStringDate(config.startDate), config.startTime);
        var durationEnd = getDateFromString(toStringDate(config.endDate), config.endTime);
        this.duration = getTimeDuration(durationStart, durationEnd);
        if (config.recurrence.type === 'doesNotRepeat') {
            this.rRule = new RRule({
                freq: RRule.DAILY,
                count: 1,
                dtstart: this.startDate,
                until: this.endDate,
                tzid: tzid
            });
        }
        else if (config.recurrence.type === 'daily') {
            if (config.doesEnd) {
                this.rRule = new RRule({
                    freq: RRule.DAILY,
                    interval: config.recurrence.value,
                    dtstart: this.startDate,
                    until: this.endDate,
                    tzid: tzid
                });
            }
            else {
                this.rRule = new RRule({
                    freq: RRule.DAILY,
                    interval: config.recurrence.value,
                    dtstart: this.startDate,
                    tzid: tzid
                });
            }
        }
        else if (config.recurrence.type === 'weekly') {
            if (config.doesEnd) {
                this.rRule = new RRule({
                    freq: RRule.WEEKLY,
                    interval: config.recurrence.value,
                    dtstart: this.startDate,
                    until: this.endDate,
                    byweekday: config.recurrence.misc.map(function (m) {
                        return getRRuleWeekFormString(m);
                    }),
                    tzid: tzid
                });
            }
            else {
                this.rRule = new RRule({
                    freq: RRule.WEEKLY,
                    interval: config.recurrence.value,
                    dtstart: this.startDate,
                    byweekday: config.recurrence.misc.map(function (m) {
                        return getRRuleWeekFormString(m);
                    }),
                    tzid: tzid
                });
            }
        }
        else if (config.recurrence.type === 'monthly') {
            var day = config.recurrence.misc.day;
            var dow = config.recurrence.misc.dow;
            var mothRule = {
                freq: RRule.MONTHLY,
                interval: config.recurrence.value,
                dtstart: this.startDate,
                until: this.endDate,
                bymonthday: day,
                tzid: tzid
            };
            if (dow && dow !== null) {
                mothRule = {
                    freq: RRule.MONTHLY,
                    interval: config.recurrence.value,
                    dtstart: this.startDate,
                    until: this.endDate,
                    byweekday: [getNthWeekDay(dow, day)],
                    tzid: tzid
                };
            }
            !config.doesEnd && delete mothRule.until;
            this.rRule = new RRule(mothRule);
        }
        return this;
    };
    ScheduleEvents.prototype.fromString = function (config, duration, rRuleString) {
        this.config = config;
        this.rRule = RRule.fromString(rRuleString);
        this.duration = duration * 60000;
        return this;
    };
    ScheduleEvents.prototype.getTimesBetween = function (start, end, occurrenceType, rruleSet) {
        var _this = this;
        // const dtstart = new Date(Date.UTC(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate(), this.startDate.getHours(), this.startDate.getMinutes(), 0))
        // const until = new Date(Date.UTC(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate(), this.endDate.getHours(), this.endDate.getMinutes(), 0))
        var events = rruleSet
            ? rruleSet.between(start, end, true)
            : this.rRule
                ? this.rRule.between(start, end, true)
                : [];
        return events.map(function (date) {
            return {
                id: date.getTime() + Math.random(),
                data_id: _this.config.eventID,
                title: _this.config.eventName,
                isHoliday: _this.config.isHoliday,
                isEnabled: _this.config.isEnabled,
                campaignId: _this.config.campaignId,
                allDay: false,
                start: date,
                end: new Date(date.getTime() + _this.duration),
                occurrenceType: occurrenceType
            };
        });
    };
    return ScheduleEvents;
}());
export { ScheduleEvents };
//# sourceMappingURL=RRulesUtils.js.map